module.exports = __webpack_public_path__ + "4250f3a7cf32982adf31672b62e80730.pdf";